var _style, _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _g, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path2, _path3, _defs, _defs2, _path4, _path5, _g2, _line, _g3, _line2, _g4, _path6, _defs3, _defs4, _g5, _g6, _g7, _path7, _path8, _text, _g8, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterface2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 1700",
    style: {
      enableBackground: "new 0 0 900 1700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7100E8;stroke:#281560;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#1E1033;stroke:#281560;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#6000C6;stroke:#281560;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#1B1544;stroke:#281560;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#5100BA;stroke:#281560;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:#2C005B;stroke:#281560;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{clip-path:url(#SVGID_00000183242286254008103220000000319735405871910041_);}\n\t.st9{fill:#5E00E5;stroke:#281560;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#281560;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#FFEC00;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#A8FF00;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#FF0074;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#00FFB6;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#FF7100;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st16{fill:none;stroke:url(#SVGID_00000170239048389100539660000010386752402822120639_);stroke-width:5.39;stroke-linecap:round;stroke-linejoin:round;}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\n\t.st18{clip-path:url(#SVGID_00000022527630123907909900000009538500801696447918_);}\n\t.st19{fill:none;stroke:#FFFFFF;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;}\n\t.st20{fill:#5E00CC;stroke:#281560;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:#FFF085;}\n\t.st22{fill:#161C09;}\n\t.st23{fill:#FF0074;stroke:#281560;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st24{fill:#FFEC00;}\n\t.st25{opacity:0.89;fill:#FFF085;}\n\t.st26{fill:#FFEC00;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st27{fill:none;stroke:#876000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st28{fill:#FFEC00;stroke:#FFEC00;stroke-width:2.987;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st29{fill:none;stroke:url(#SVGID_00000168085350723192757390000002483509572260123040_);stroke-width:5.39;stroke-linecap:round;stroke-linejoin:round;}\n\t.st30{font-family:'ChildChat';}\n\t.st31{font-size:30px;}\n\t.st32{fill:#A8FF00;}\n\t.st33{fill:#FFFFFF;}\n\t.st34{font-size:39px;}\n\t.st35{font-size:32px;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "INTERFACE_BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.6,
    y: 1418.3,
    className: "st0",
    width: 848.9,
    height: 185.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.6,
    y: 1256.4,
    className: "st1",
    width: 848.9,
    height: 149.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.6,
    y: 1406.1,
    className: "st2",
    width: 848.9,
    height: 12.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.6,1603.7h848.9v51.3c0,4.8-3.9,8.6-8.6,8.6H34.2c-4.8,0-8.6-3.9-8.6-8.6L25.6,1603.7L25.6,1603.7 L25.6,1603.7z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.6,
    y: 1448.6,
    className: "st3",
    width: 679.5,
    height: 108.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 735.1,
    y: 1448.6,
    className: "st4",
    width: 109.2,
    height: 108.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 55.6,
    y: 1556.8,
    className: "st2",
    width: 788.8,
    height: 16.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M789.4,1468.1h0.7c19.1,0,34.6,15.5,34.6,34.6l0,0c0,19.1-15.5,34.6-34.6,34.6h-0.7 c-19.1,0-34.6-15.5-34.6-34.6l0,0C754.8,1483.6,770.3,1468.1,789.4,1468.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 789.8,
    y1: 1522.6,
    x2: 789.8,
    y2: 1503.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 789.8,
    y1: 1486.1,
    x2: 789.8,
    y2: 1482.7
  })))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 55.6,
    y: 1256.4,
    className: "st1",
    width: 112.7,
    height: 13
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 168.3,
    y: 1256.4,
    className: "st1",
    width: 112.7,
    height: 13
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 281,
    y: 1256.4,
    className: "st1",
    width: 112.7,
    height: 13
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 393.7,
    y: 1256.4,
    className: "st1",
    width: 112.7,
    height: 13
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 506.3,
    y: 1256.4,
    className: "st1",
    width: 112.7,
    height: 13
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 1256.4,
    className: "st1",
    width: 112.7,
    height: 13
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 731.7,
    y: 1256.4,
    className: "st1",
    width: 112.7,
    height: 13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.7,474.6h832.5c4.5,0,8.2,3.7,8.2,8.2v773.7H25.6V482.7C25.6,478.2,29.2,474.6,33.7,474.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M55.6,1025.9V625c0-21.2,17.2-38.5,38.5-38.5h711.8c21.2,0,38.5,17.2,38.5,38.5v560.3 c0,21.2-17.2,38.5-38.5,38.5H94.1c-21.2,0-38.5-17.2-38.5-38.5V1025.9L55.6,1025.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 64.2,
    y: 593.9,
    width: 771.5,
    height: 621.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115484904405749754600000006723492833446270365_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000115484904405749754600000006723492833446270365_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000108997905057677620720000006904415764199601078_",
    x: 64.2,
    y: 593.9,
    width: 771.5,
    height: 621.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100351642518820722050000015223654053377815203_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108997905057677620720000006904415764199601078_",
    style: {
      overflow: "visible"
    }
  })))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M43.4,508c4.2-11.4,16.2-18.4,27.7-15.1c12.1,3.5,19.2,17.1,16.6,29.6c-3,14.1-17.5,23.1-30.4,18.2 C44.9,536.2,38.7,520.8,43.4,508z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M43,525.1c14.7-5.2,29.3-10.5,44-15.8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M829.7,492.1c-11.8-0.3-22.5,8.9-24.4,21c-2.4,14.6,8.6,29.5,23,30.1c13.2,0.5,25.2-11.3,25-25.8 C853.1,503.6,842.3,492.5,829.7,492.1L829.7,492.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M819.1,494.4c5.7,15.8,11.5,31.7,17.2,47.5"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 25.6,
    y1: 559.2,
    x2: 874.4,
    y2: 559.2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M497,530.5c-0.7-17.3-0.7-33,1.4-33.3c3.2-0.4,8.8,33.7,12.2,33.3c1.6-0.2,2.7-7.6,2-34.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M277.1,531.4c-0.4-10.5-0.9-33.8,3.3-34.5c4.5-0.8,12.2,24.1,15.1,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M271.4,525.8c9-2.3,18.1-4.6,27.2-7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M561.2,531.6c0.1-11.1,0.2-22.2,0.2-33.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M561.4,498.3c6-2.6,12.4-0.9,15.1,3.2c1.5,2.2,2.2,5.6,1,8.5c-1.6,3.9-5.4,3.8-6.3,6.3 c-0.8,2.4,1.1,6.7,12.9,15.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M444.4,497.9c-1.1-0.2-10.6-1.5-17.4,5.3c-3.4,3.4-7.3,10.1-5,16.4c2.1,5.9,8.5,8.2,12.1,9.5 c5,1.8,9.5,1.7,12,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M314.5,497.3c-4.4,16.9-2.7,30.1,3.7,33.2c3.2,1.5,6.6,0.1,6.8,0c6.9-3.1,9.5-16.4,5.9-33.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M632.9,497.7c1,7,0.9,12.8,0.6,16.9c-0.7,8.7-2.8,14.8,0,16.8c1.2,0.8,2.5,0.4,5.1,0 c3.5-0.5,8.6-0.9,15.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M346.8,497.7c1,7,0.9,12.8,0.6,16.9c-0.7,8.7-2.8,14.8,0,16.8c1.2,0.8,2.5,0.4,5.1,0 c3.5-0.5,8.6-0.9,15.1,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M537.3,497c0.4,11.5,0.8,23,1.1,34.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M528.2,497h18.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M381.4,497c0.4,11.5,0.8,23,1.1,34.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M372.3,497H391"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M245.1,495.8c1,12.1,3.3,36.3,7,36.4c3.7,0.1,7.1-23.9,8.6-35.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M607.6,496.7c-5.9-0.1-10.4,6.9-11.9,11.9c-2.8,8.9,1,21.1,7.8,22.6c6.6,1.4,15.5-7.4,16.1-16.7 C620.1,506.3,614.4,496.8,607.6,496.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M470.7,496.7c-5.9-0.1-10.4,6.9-11.9,11.9c-2.8,8.9,1,21.1,7.8,22.6c6.6,1.4,15.5-7.4,16.1-16.7 C483.1,506.3,477.5,496.8,470.7,496.7L470.7,496.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152986085994529092750000011658211172705400477_",
    gradientUnits: "userSpaceOnUse",
    x1: 732.915,
    y1: 922.2449,
    x2: 167.085,
    y2: 922.2449,
    gradientTransform: "matrix(1 0 0 -1 0 1700)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A8FF00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000152986085994529092750000011658211172705400477_)",
      strokeWidth: 5.39,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: " M176.8,745h546.4c3.9,0,7,3.1,7,7v51.6c0,3.9-3.1,7-7,7H176.8c-3.9,0-7-3.1-7-7V752C169.8,748.1,172.9,745,176.8,745z"
  }), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 810.5,
    y1: 670.8,
    x2: 90.1,
    y2: 670.8
  }))), /*#__PURE__*/React.createElement("g", null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.1,36.3h831.8c4.7,0,8.5,3.8,8.5,8.5v383.3c0,4.7-3.8,8.5-8.5,8.5H34.1c-4.7,0-8.5-3.8-8.5-8.5V44.9 C25.6,40.2,29.4,36.3,34.1,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M43.4,67.6c4.2-10.7,16.2-17.2,27.7-14.1c12.1,3.3,19.2,16,16.6,27.7c-3,13.2-17.5,21.6-30.4,17.1 C44.9,94,38.7,79.6,43.4,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M43.4,67.6C57.4,74,71.5,80.4,85.6,86.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 25.6,
    y1: 115.6,
    x2: 874.4,
    y2: 115.6
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M70.6,148.3h758.8c8.3,0,15,6.7,15,15v207.3c0,8.3-6.7,15-15,15H70.6c-8.3,0-15-6.7-15-15V163.3 C55.6,155,62.3,148.3,70.6,148.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000054233260111935235090000008861247608327151279_",
    x: 64.2,
    y: 155.7,
    width: 771.5,
    height: 220.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173845553900395113960000004883267890377117580_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054233260111935235090000008861247608327151279_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000173845553900395113960000004883267890377117580_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000113313399510350805150000000251065106153586825_",
    x: 64.2,
    y: 155.7,
    width: 771.5,
    height: 220.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118381927826919709450000000814458501069627816_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113313399510350805150000000251065106153586825_",
    style: {
      overflow: "visible"
    }
  })))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M470.8,92.3c-0.7-17.3-0.8-33.1,1.4-33.4c3.2-0.4,8.8,33.8,12.2,33.4c1.6-0.2,2.7-7.6,2-34.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M435.3,93.2c-0.4-10.5-0.9-33.8,3.3-34.5c4.5-0.8,12.2,24.2,15.1,33.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M429.6,87.5c9.1-2.3,18.1-4.7,27.2-7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M359,93.2c-0.4-10.5-0.9-33.8,3.3-34.5c4.5-0.8,12.2,24.2,15.1,33.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M353.4,87.5c9.1-2.3,18.1-4.7,27.2-7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M553,60.2c-6.1-2.2-8.9-0.6-9.7,0c-2,1.5-2.3,3.8-2.7,16.3c-0.5,12.1-0.4,13.9,1.2,15.4 c3.9,3.6,11.8,0.6,13.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M551.8,76.5h-11.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M524.3,59.5c-1.1-0.2-10.6-1.5-17.4,5.4c-3.4,3.4-7.3,10.1-5,16.4c2.1,5.9,8.5,8.2,12.1,9.5 c5,1.8,9.5,1.7,12.1,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M581.8,58.3c-0.5-0.1-4.3-1-7.4,1.6c-1.9,1.5-3.4,4.3-2.9,6.8c1,5,8.9,4,12.6,10.6 c0.3,0.6,3.1,5.7,0.6,10.2c-1.5,2.8-4.7,4.6-8,4.6c-3.7,0.1-7.1-2.1-8.8-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M394.3,59.4c1,7.1,0.9,12.8,0.6,16.9c-0.7,8.7-2.8,14.8,0,16.8c1.2,0.8,2.5,0.4,5.1,0 c3.5-0.5,8.6-0.9,15.1,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M314.3,58.5c0.1,11.5,0.2,23,0.2,34.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M314.3,58.5c0.8-0.3,6.1-2.3,11.2,0.6c3.6,2,7.3,6.6,6.2,11.4c-0.7,2.9-2.8,4.6-3.8,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M327.9,75.8c3.6-0.5,7,0.8,8.8,3.5c2,2.9,1.2,6.6,0.3,8.5c-2.6,5.3-11.6,7.6-22.5,5.2"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SECTION_BUTTONS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Locked_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M731.7,1269.4h112.7v106c0,5.5-4.5,10-10,10h-92.7c-5.5,0-10-4.5-10-10V1269.4L731.7,1269.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M763,1325.8h50.3c1,1.7,8.8,14.6,3.5,26.6c-6.3,14.3-26.3,16.6-38.8,13.2c-3.9-1.1-14.1-3.8-18.6-13.6 C753.5,1339.4,762.6,1326.4,763,1325.8L763,1325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M784,1358.1h6.2v-12.4c3.2-1.7,4.8-4.9,4.1-7.7c-0.9-3.6-5.1-4.5-5.7-4.6c-2.9-0.6-7.6-0.1-9,3.4 c-1.2,3.1,0.6,7.3,4.6,8.9C784.2,1349.8,784.1,1354,784,1358.1L784,1358.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M779.2,1325.8v-21c0-4.9,4-8.9,8.8-8.9s8.8,4,8.8,8.9v21h7.7v-21.5c0-9.2-7.4-16.6-16.6-16.6 s-16.6,7.4-16.6,16.6v21.5H779.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Locked_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M619,1269.4h112.7v106c0,5.5-4.5,10-10,10H629c-5.5,0-10-4.5-10-10V1269.4L619,1269.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M650.4,1325.8h50.3c1,1.7,8.8,14.6,3.5,26.6c-6.3,14.3-26.3,16.6-38.8,13.2c-3.9-1.1-14.1-3.8-18.6-13.6 C640.8,1339.4,649.9,1326.4,650.4,1325.8L650.4,1325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M671.3,1358.1h6.2v-12.4c3.2-1.7,4.8-4.9,4.1-7.7c-0.9-3.6-5.1-4.5-5.7-4.6c-2.9-0.6-7.6-0.1-9,3.4 c-1.2,3.1,0.6,7.3,4.6,8.9C671.5,1349.8,671.4,1354,671.3,1358.1L671.3,1358.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M666.5,1325.8v-21c0-4.9,4-8.9,8.8-8.9s8.8,4,8.8,8.9v21h7.7v-21.5c0-9.2-7.4-16.6-16.6-16.6 s-16.6,7.4-16.6,16.6v21.5H666.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Locked_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M506.3,1269.4H619v106c0,5.5-4.5,10-10,10h-92.7c-5.5,0-10-4.5-10-10L506.3,1269.4L506.3,1269.4 L506.3,1269.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M537.2,1325.8h50.3c1,1.7,8.8,14.6,3.5,26.6c-6.3,14.3-26.3,16.6-38.8,13.2c-3.9-1.1-14.1-3.8-18.6-13.6 C527.7,1339.4,536.8,1326.4,537.2,1325.8L537.2,1325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M558.2,1358.1h6.2v-12.4c3.2-1.7,4.8-4.9,4.1-7.7c-0.9-3.6-5.1-4.5-5.7-4.6c-2.9-0.6-7.6-0.1-9,3.4 c-1.2,3.1,0.6,7.3,4.6,8.9C558.3,1349.8,558.2,1354,558.2,1358.1L558.2,1358.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M553.4,1325.8v-21c0-4.9,4-8.9,8.8-8.9s8.8,4,8.8,8.9v21h7.7v-21.5c0-9.2-7.4-16.6-16.6-16.6 s-16.6,7.4-16.6,16.6v21.5H553.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "EXTEND_LOCK"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M281,1269.4h112.7v106c0,5.5-4.5,10-10,10H291c-5.5,0-10-4.5-10-10V1269.4L281,1269.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M379,1310.8c-2-1.4-4.8-0.9-6.3,1.1l-2.4,3.4c-4.3-17.1-17.5-29.6-33-29.6c-8.2,0-16.2,3.6-22.5,10 c-1.7,1.8-1.7,4.6,0.1,6.4s4.6,1.7,6.4-0.1c4.6-4.8,10.1-7.3,16-7.3c11.8,0,21.7,10.3,24.6,24.3l-5.5-3.2 c-2.1-1.3-4.9-0.6-6.2,1.6c-1.3,2.1-0.6,4.9,1.6,6.2l13.1,7.8c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0,0,0,0,0.1,0 c0,0,0,0,0.1,0c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0 c0.2,0,0.4,0,0.6,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0,0.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0 c0.1,0,0.2,0,0.2-0.1c0.1,0,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.1-0.1,0.2-0.1 c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.2c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0.1-0.1 c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0.1-0.1,0.1-0.1l9.1-12.9C381.5,1315,381,1312.2,379,1310.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M353.3,1352.8c-4.6,4.8-10.1,7.3-16,7.3c-11.4,0-21.1-9.7-24.4-23l4.9,3.6c0.8,0.6,1.7,0.9,2.6,0.9 c1.4,0,2.8-0.6,3.6-1.9c1.5-2,1-4.8-1-6.3l-13.2-9.6c0,0,0,0-0.1,0c-0.1-0.1-0.2-0.1-0.4-0.2c-0.1-0.1-0.2-0.1-0.3-0.2 c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.4,0c-0.1,0-0.3,0-0.4-0.1 c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.4,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0.1-0.4,0.1 c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.1,0.1-0.1,0.1 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.1-0.2,0.2 l-9.5,12.3c-1.5,2-1.2,4.8,0.8,6.3c0.8,0.6,1.8,0.9,2.7,0.9c1.3,0,2.7-0.6,3.6-1.8l2.8-3.6c4.1,17.4,17.4,30.2,33.2,30.2 c8.2,0,16.2-3.6,22.5-10c1.7-1.8,1.7-4.6-0.1-6.4C357.9,1351,355,1351,353.3,1352.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "GMBEE_STATS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M393.7,1269.4h112.7v106c0,5.5-4.5,10-10,10h-92.7c-5.5,0-10-4.5-10-10V1269.4L393.7,1269.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 1337.2,
    className: "st21",
    width: 19.2,
    height: 32.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.4,
    y: 1285.2,
    className: "st21",
    width: 19.2,
    height: 84.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.9,
    y: 1309.8,
    className: "st21",
    width: 19.2,
    height: 59.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lock_Up_GMB_Section_Highlighted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M168.3,1269.4H281v106c0,5.5-4.5,10-10,10h-92.7c-5.5,0-10-4.5-10-10L168.3,1269.4L168.3,1269.4 L168.3,1269.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lock_Up_GMB_Section_00000017480096587110059720000015939348909608848020_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M255.2,1289.6v39.8v5.6v20.6h-60.8v-19v-7.1v-39.8h-10.6v39.8v7.1v22.8c0,4.1,3.1,7.4,7,7.4h3.6v0h60.8v0 h3.6c3.9,0,7-3.3,7-7.4v-24.3v-5.6v-39.8H255.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M212.6,1305.6c8.3,0,16.6,0,24.8,0c0,13,0,26,0,39c-8.3,0-16.7-0.1-25-0.1 C212.5,1331.6,212.5,1318.6,212.6,1305.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M232.5,1318.7c-0.4-3.7-4.2-6.5-8.1-6.3c-3.7,0.2-7.2,3-7.4,6.8c-0.1,3.4,2.5,6.2,5.6,7 c-1.1,3.3-2.2,6.6-3.3,9.8c3.7-0.1,7.4-0.1,11.1-0.2c-1.2-3.2-2.3-6.5-3.5-9.7C230.3,1325.1,232.9,1322,232.5,1318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M212.6,1305.6c8.3,0,16.6,0,24.8,0c0,5.9,0,11.7,0,17.6h17.8v-25.2c-4.1-3-9.2-4.7-14.7-4.7h-31.4 c-5.5,0-10.6,1.8-14.7,4.7v25.2c6,0,12.1,0,18.1,0C212.5,1317.4,212.6,1311.5,212.6,1305.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M237.4,1329.4c0,5.1,0,10.2,0,15.3c-8.3,0-16.7-0.1-25-0.1c0-5.1,0-10.2,0.1-15.3h-0.1h-4.8h-13.2v26.1 h60.8v-26.1H237.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Connect_Wallet_Section"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M55.6,1269.4h112.7v106c0,5.5-4.5,10-10,10H65.6c-5.5,0-10-4.5-10-10L55.6,1269.4 C55.6,1269.4,55.6,1269.4,55.6,1269.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M143.6,1289.2c-5.8-5.6-15-5.4-20.5,0.4c-4.9,5.1-5.3,12.7-1.5,18.3c-2,2.1-3.9,4.1-5.7,6l-2-1.9 c-0.9-0.9-2.3-0.8-3.2,0.1c-0.9,0.9-0.8,2.3,0.1,3.2l2,1.9c-5.1,5.3-10.2,10.6-15.3,15.9l0,0c-0.9,0.9-1.8,1.8-2.7,2.8 c-0.9,0.9-1.7,1.8-2.6,2.7c-4.2,4.4-8.9,9.2-14.6,15.2c-1.4,1.5-1.1,3.8,0.3,4.8c1.2,0.8,3,0.7,4.1-0.5c1.3-1.4,2.6-2.8,4-4.1 c5.5,5.3,10.9,10.5,16.4,15.8c2.2-2.2,5.5-5.7,6.1-6.4c0.1-0.1,1-1.1,1.1-1.2c0.2-0.2,1.4-1.4,1.6-1.7c0,0,6.9-7.2,6.9-7.2 c-5.5-5.3-10.9-10.5-16.4-15.8l0,0l0.1,0c5.1-5.3,10.3-10.7,15.4-16c0.6,0.6,1.2,1.2,1.8,1.7c0.9,0.9,2.3,0.8,3.2-0.1 c0.9-0.9,0.8-2.3-0.1-3.2l-1.8-1.7c1.7-1.8,3.6-3.7,5.8-6c5.7,3.5,13.2,2.6,18-2.3C149.5,1304,149.3,1294.8,143.6,1289.2z  M139.8,1305.7c-3.3,3.5-8.9,3.6-12.3,0.2c-3.5-3.3-3.6-8.9-0.2-12.3c3.3-3.5,8.9-3.6,12.3-0.2 C143,1296.8,143.1,1302.3,139.8,1305.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clickable"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "X_Button_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M829.7,52.7c-11.8-0.3-22.5,8.4-24.4,19.7c-2.4,13.7,8.6,27.6,23,28.1c13.2,0.5,25.2-10.6,25-24.2 C853.1,63.5,842.3,53.1,829.7,52.7L829.7,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M820.1,85.6c6.2-6.4,12.4-12.7,18.6-19.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M818.9,65.5c6.4,6.8,12.9,13.6,19.3,20.5"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Arrow_Left",
    className: "st28",
    d: "M90.1,946.6c13.3-12.9,26.5-25.7,39.8-38.6v78.4C116.6,973.2,103.3,959.9,90.1,946.6 L90.1,946.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Arrow_Right",
    className: "st28",
    d: "M810.5,946.6c-13.3-12.9-26.5-25.7-39.8-38.6c0,26.1,0,52.3,0,78.4 C783.9,973.2,797.2,959.9,810.5,946.6L810.5,946.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LOCK"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085217136731873636440000013734610431437441951_",
    gradientUnits: "userSpaceOnUse",
    x1: 568.815,
    y1: 569.59,
    x2: 331.185,
    y2: 569.59,
    gradientTransform: "matrix(1 0 0 -1 0 1700)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A8FF00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000085217136731873636440000013734610431437441951_)",
      strokeWidth: 5.39,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: " M340.9,1083.1h218.2c3.9,0,7,3.1,7,7v80.7c0,3.9-3.1,7-7,7H340.9c-3.9,0-7-3.1-7-7v-80.7C333.9,1086.2,337,1083.1,340.9,1083.1z"
  }), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 410.54 1141.3101)",
    className: "st24 st30 st31"
  }, "LOCK")))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Vault_Control_Text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_0_GMB"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 185.72 787.97)",
    className: "st32 st30 st31"
  }, "0")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 315.47 651.74)",
    className: "st33 st30 st34"
  }, "LOCK UP GMB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 169.78 731)",
    className: "st24 st30 st35"
  }, "LOCK AMOUNT: (MIN. 1.000 GMB):"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 169.78 880.97)",
    className: "st33 st30 st35"
  }, "LOCK DURATION: "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 436.5291 880.97)",
    className: "st32 st30 st34"
  }, "3 MONTHS"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 77.45 1494.38)",
    className: "st33 st30 st35"
  }, "LOCK GMB: LOCK YOUR GMB FOR  "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 77.45 1532.78)",
    className: "st33 st30 st35"
  }, "JUICY REWARDS."))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Balances_Text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Balances_Text_2"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 129.87 219.6)",
    className: "st33 st30 st35"
  }, "GMB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 129.87 276.67)",
    className: "st33 st30 st35"
  }, "GMBEE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 129.87 333.74)",
    className: "st33 st30 st35"
  }, "MAGIC BEANS"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 513.38 219.6)",
    className: "st33 st30 st35"
  }, "????????????"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 513.38 276.67)",
    className: "st33 st30 st35"
  }, "????????????"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 513.38 333.74)",
    className: "st32 st30 st35"
  }, "M A G I C ?")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterface2);
export default __webpack_public_path__ + "static/media/interface-2.3394d9f366673f428a54f04c0c1d826d.svg";
export { ForwardRef as ReactComponent };